// This file is auto-generated by online/ops/maven/online-maven-plugin

export enum ApiVerb {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  DELETE = 'DELETE',
}

// UI API specific type that is evaluated out of the endpoints that have it, luckily this is our
// generator so we can have things like this!
export interface LimitableQuery {
  limit?: number;
  offset?: number;
}

export interface SortableLimitableQuery extends LimitableQuery {
  order?: string;
  sort?: string;
}

export enum ApiType {
  
  PRIVATE = 'Private',
  PUBLIC = 'Public',

}

export interface ApiMethod {
  path: string;
  type: ApiType;
  verb: ApiVerb;
}

const replacePathParams = (path: string, pathParams: { [param: string]: string }): string => {
  let processedPath = path;
  for (let param of Object.keys(pathParams)) {
    if (pathParams.hasOwnProperty(param)) {
      processedPath = processedPath.replace(`{${param}}`, pathParams[param]);
    }
  }
  return processedPath;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getQueryString = (query?: {[param: string]: any}): string => {
  let queryString = '';
  if (query) {
    for (let param of Object.keys(query)) {
      if (query.hasOwnProperty(param) && query[param] !== undefined && query[param] !== null) {
        if (!queryString) {
          queryString += '?';
        } else {
          queryString += '&';
        }
        queryString += param + '=' + encodeURIComponent(String(query[param]));
      }
    }
  }
  return queryString;
}



export const prepareLoginPublicMethod = (query: {  callPath: string; locale: string; noPrompt?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/prepare-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const processLoginPublicMethod = (query: {  code: string; state: string; error?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/process-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const validateSessionPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/validate',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const logoutPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/public/auth/logout',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelsV3PublicMethod = (query?: {  subscriptionType?: string; category?: string; addressId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v3/public/online-models' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const refreshSessionPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/auth/refresh-session',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v3/private/orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const logInPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logInAndSavePrimaryAccountPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in-and-save-primary-account',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logInAndAddMissingMobileNumberPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/log-in-and-add-missing-mobile-number',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const validatePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/validate',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const resolveMissingPrimaryAccountPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/resolve-missing-primary-account',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const prepareElisaIdV2LoginPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/prepare-elisaid-login',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const processElisaIdV2LoginPublicMethod = (query: {  authCode: string; redirectUrl: string; onboardingId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/process-elisaid-login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getExternalAuthorizationRequestPublicMethod = (linkToken: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/auth/external/requests/{linkToken}', {linkToken: linkToken,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const authorizeExternalAuthorizationRequestPublicMethod = (linkToken: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/auth/external/requests/{linkToken}/authorize', {linkToken: linkToken,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const getExternalAuthenticationMethodsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/authentication-methods',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const validateExternalAuthenticationUserAuthorityPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/validate-user-authority',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const registerExternalAuthenticationUserPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/register-user',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const checkSsoUserExistsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/external/check-user-exists',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const verifyEmailPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/verify-email',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const resetPasswordPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/reset-password',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const validateOtpPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/validate-otp',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const sendOtpToUserPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/auth/send-otp-to-user',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const searchCompaniesPublicMethod = (query: {  query: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/companies/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getSitemapPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/sitemap',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getImageSitemapPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/sitemap/image',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getPagePublicMethod = (query: {  path: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/pages' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getPage2PublicMethod = (query: {  path: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/pages2' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const searchPagesPublicMethod = (query: {  query: string; start: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/pages/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getAddOnRulesPublicMethod = (query?: {  subscriptionType?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/add-on-rules' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getAddOnVisibilityPublicMethod = (commercialProductCode: string, query: {  operationType: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/metadata/addon-visibility/{commercialProductCode}', {commercialProductCode: commercialProductCode,}) + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getBillChannelsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/bill-channels',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getHolidaysPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/metadata/holidays',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelsPublicMethod = (query: {  headersOnly: boolean; category?: string; tags?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/online-models' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModels2PublicMethod = (query: {  headersOnly: boolean; category?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/online-models2' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelPublicMethod = (onlineModelCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModel2PublicMethod = (onlineModelCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/online-models2/{onlineModelCode}', {onlineModelCode: onlineModelCode,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const searchAddressPublicMethod = (query: {  query: string; postalCode: string; filter?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/addresses/search' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getCommercialAvailabilityPublicMethod = (query: {  subscriptionType: string; addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/addresses/commercial-availability' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const createAnonymousSupportCasePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/support-cases',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const createAnonymousLeadPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/leads',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const getCampaignsPublicMethod = (query: {  salesType: string; voucher: string; onlineModel: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/campaigns' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getNavigationPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/navigation',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const proxyGetPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const proxyPostPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const proxyPutPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.PUT,
  };
};

export const proxyDeletePublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/yagh',
    type: ApiType.PUBLIC,
    verb: ApiVerb.DELETE,
  };
};

export const getTrainingPublicMethod = (trainingId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/trainings/{trainingId}', {trainingId: trainingId,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const domainGetPublicMethod = (query: {  query: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/domains' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductFeedForCategoryPublicMethod = (messageType: string, category: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/product-feed/{messageType}/{category}', {messageType: messageType,category: category,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getProductFeedPublicMethod = (messageType: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/public/product-feed/{messageType}/all_devices', {messageType: messageType,}),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const punchoutLoginPublicMethod = (query: {  accountId: string; password: string; username: string; catalogName?: string; session?: string; origin?: string; customer?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/punchout/login' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const licenseManagementUrlPublicMethod = (query: {  accountId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/get-license-management-url' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getLicenseManagementAccountsPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/get-license-management-accounts',
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const getChatHistoryPublicMethod = (query: {  sessionId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/public/chat/history' + getQueryString(query),
    type: ApiType.PUBLIC,
    verb: ApiVerb.GET,
  };
};

export const postChatConversationPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/chat/conversation',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const redirectCanvasRequestOpenFormPublicMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/public/sf',
    type: ApiType.PUBLIC,
    verb: ApiVerb.POST,
  };
};

export const logOutPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/log-out',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const elisaIdV2LogOutPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/elisaid-log-out',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changePasswordPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/change-password',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const raiseAuthenticationLevelPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/raise-level',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const raiseAuthenticationLevelValidateOtpPrivateMethod = (otp: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/auth/raise-level/validate/{otp}', {otp: otp,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const resolveUserNameConflictPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/resolve-user-name-conflict',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const switchAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/switch-account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const identifyStronglyPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auth/identify-strongly',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getMyselfAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateMyselfAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getMyselfSecondaryAccountsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/secondary-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMyselfUserPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/user',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getAccountKeyUsersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account/key-users',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateAccountKeyUserPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/account/key-users',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getAccountKeyUsersByServiceAgreementIdPrivateMethod = (serviceAgreementId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/myself/account/key-users/{serviceAgreementId}', {serviceAgreementId: serviceAgreementId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const updateMyselfContactPrivateMethod = (query?: {  onboardingId?: string; forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/contact' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getMyselfChangesPrivateMethod = (query?: {  latestChangeRef?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/changes' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const resendVerifyEmailLinkPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/myself/resend-verify-email-link',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getDiscountedPricesPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/customer-level-discounted-prices',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getEppSolutionPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/company-info/epp-solution-jit-failure-workaround',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getContactsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; contactMasterId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createContactPrivateMethod = (query?: {  forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateContactPrivateMethod = (contactId: string, query?: {  bothNamesChanged?: boolean; forceUpsert?: boolean; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}', {contactId: contactId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getContactBillingAccountsPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/billing-accounts', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createAdminUserPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/users', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const deleteAdminUserPrivateMethod = (contactId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contacts/{contactId}/users', {contactId: contactId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const checkDuplicateContactsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/duplicate-check',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const validateMoveContactPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact/validate',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const hasPendingActionsForContactPrivateMethod = (query: {  contactMasterId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact/pending-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const submitMoveContactPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contacts/move-contact',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createShoppingCartPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/shopping-carts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateShoppingCartPrivateMethod = (shoppingCartId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/shopping-carts/{shoppingCartId}', {shoppingCartId: shoppingCartId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getBillingAccountsPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; sourceSystem?: string; billingContactId?: string; billingAccountDisplayId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/billing-accounts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateBillingAccountPrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getBillingAccountScheduledChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postScheduledBillingAccountChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const putScheduledBillingAccountChangePrivateMethod = (billingAccountId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/billing-accounts/{billingAccountId}/scheduled-change', {billingAccountId: billingAccountId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getSupportCaseHistoryPrivateMethod = (supportCaseDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/support-cases/{supportCaseDisplayId}/history', {supportCaseDisplayId: supportCaseDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSupportCasePrivateMethod = (supportCaseDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/support-cases/{supportCaseDisplayId}', {supportCaseDisplayId: supportCaseDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSupportCasesPrivateMethod = (query?: SortableLimitableQuery & {  search?: string; feature?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createSupportCasePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenSupportCasesPrivateMethod = (query?: SortableLimitableQuery & {  search?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/support-cases/open-support-cases' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postFilePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/files',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createLeadPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/leads',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getSubscriptionsPrivateMethod = (query?: SortableLimitableQuery & {  subscriptionDisplayId?: string; subscriptionSubType?: string; contactId?: string; billingAccountId?: string; fetchOwnSubscriptionsOnly?: boolean; paymentType?: string; useSearchService?: boolean; deviceUser?: string; search?: string; expiringOrExpired?: boolean; subscriptionType?: string[]; subscriptionToken?: string; commitmentPeriod?: string; eppOnly?: boolean; eppFilter?: string; details?: boolean; expiringFilter?: string; reporting?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscriptions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSubscriptionPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getLocalUsagePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/local-usage', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getRoamingUsagePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/roaming-usage', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getVoiceCallsPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/voice-calls', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getTextMessagesPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/text-messages', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMonthlyUsageDetailsPrivateMethod = (month: string, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/usage-details/{month}', {month: month,subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const startBbfPrivateMethod = (subscriptionId: string, locale: string, portal: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/{locale}/{portal}/start-bbf', {subscriptionId: subscriptionId,locale: locale,portal: portal,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const startMfPrivateMethod = (subscriptionId: string, locale: string, portal: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/{locale}/{portal}/start-mf', {subscriptionId: subscriptionId,locale: locale,portal: portal,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const redeemOrTerminateEppPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/epp-redeem-terminate', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const maintenanceEppPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/epp-maintenance', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionBillingAccountPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-billing-account', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionUserInformationPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-user-information', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionTerminateDeviceServicePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/terminate-device-service', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionChangeSimPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-sim', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionSuspendPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/suspend', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionResumePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/resume', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionTerminatePrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/terminate', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionFeaturesPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-features', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionMobilePbxPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-mobile-pbx', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeSubscriptionMobilePbxSolutionPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-mobile-pbx-solution', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const changeOwnerAccountPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/subscriptions/{subscriptionId}/change-owner', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getSubscriptionAggregationsPrivateMethod = (query: {  subscriptionCategory: string; search?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscription-aggregations' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const hasPendingSubscriptionActionsPrivateMethod = (query: {  subscriptionDisplayId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/pending-subscription-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createOnlineOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const searchForPickupPointPrivateMethod = (query: {  service: string; maxResults: string; postalCode: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/pickup-points' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCreditCheckResultPrivateMethod = (query: {  onlineOrderId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/credit-check' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const initializeOnlineOrderCardPaymentPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/initialize-card-payment',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const finalizeOnlineOrderCardPaymentPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-orders/finalize-card-payment',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getCustomerOrdersPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; customerOrderDisplayId?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getUserCustomerOrdersPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; search?: string; customerOrderDisplayId?: string; status?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employee-customer-orders' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getCustomerOrderAdditionalInfoPrivateMethod = (customerOrderDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/customer-orders/{customerOrderDisplayId}/additional-info-for-approver', {customerOrderDisplayId: customerOrderDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getSubscriptionActionsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; own?: boolean; subscriptionActionDisplayId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/subscription-actions' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getValidatePortablePrivateMethod = (query: {  msisdn: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/validate-portable' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const prereserveNumbersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/prereserve',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getNumberRangePrivateMethod = (rangeId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/resources/numbers/ranges/{rangeId}', {rangeId: rangeId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const generateNumbersPrivateMethod = (query: {  count: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/generate' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const validateAvailabilityOfNumbersPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/numbers/validate-availability',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getValidateSimFreePrivateMethod = (query: {  iccidNumber: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/resources/sims/validate-free' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const requestEmployeeOtpForPairingPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/request-otp-for-pairing',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const validateEmployeeOtpAndPairPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/validate-otp-and-pair',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const createEmployeePersonBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateEmployeePersonBillingAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/billing-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const initiateEmployeeOnBoardingPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/onboard',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOnboardingRequestsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employees/onboarding-requests',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const reviewAsEmployerPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/employers/review',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getInvoicesPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; invoiceDisplayId?: string; balanceRange?: string; openInvoicesOnly?: boolean; paidInvoicesOnly?: boolean; skipBillingAccounts?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/invoices' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const initializeInvoicePaymentPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/initialize-payment', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const finalizeInvoicePaymentPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/finalize-payment', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getInvoicePrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getInvoicePdfPrivateMethod = (invoiceId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/{invoiceId}/pdf', {invoiceId: invoiceId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDocumentsPrivateMethod = (query?: SortableLimitableQuery & {  useSearchService?: boolean; documentType?: string[]; skipBillingAccounts?: boolean; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/invoices/documents' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDocumentPrivateMethod = (invoiceDocumentId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/documents/{invoiceDocumentId}', {invoiceDocumentId: invoiceDocumentId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getInvoiceDocumentPdfPrivateMethod = (invoiceDocumentId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/invoices/documents/{invoiceDocumentId}/pdf', {invoiceDocumentId: invoiceDocumentId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelWithEffectivePricesPrivateMethod = (onlineModelGuid: string, query?: {  salesType?: string; voucher?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/online-models/{onlineModelGuid}/effective-prices', {onlineModelGuid: onlineModelGuid,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelsPrivateMethod = (query?: {  onlineModelCodes?: string[]; category?: string; voucherCode?: string; tags?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/online-models' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOnlineModelPrivateMethod = (onlineModelCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/online-models/{onlineModelCode}', {onlineModelCode: onlineModelCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const searchAddressPrivateMethod = (query: {  query: string; postalCode?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/addresses/search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordsHistoryPrivateMethod = (subscriptionId: string, query?: {  nextCursor?: string; sortOrder?: string; limit?: number; sortField?: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/history', {subscriptionId: subscriptionId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordHistoryPrivateMethod = (historyId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/history/{historyId}', {historyId: String(historyId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getDnsRecordsPrivateMethod = (subscriptionId: string, query?: {  nextCursor?: string; sortOrder?: string; limit?: number; sortField?: string; type?: string[]; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records', {subscriptionId: subscriptionId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createDnsRecordPrivateMethod = (subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records', {subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateDnsRecordPrivateMethod = (recordId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records/{recordId}', {recordId: String(recordId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const deleteDnsRecordPrivateMethod = (recordId: number, subscriptionId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/domains/{subscriptionId}/records/{recordId}', {recordId: String(recordId),subscriptionId: subscriptionId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const validateAuxiliaryEsimOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auxiliary-esim-orders/validate',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postAuxiliaryEsimOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/auxiliary-esim-orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getVirtualCatalogsPrivateMethod = (query?: LimitableQuery & {  useSearchService?: boolean; search?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const createVirtualCatalogPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const replaceVirtualCatalogsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/virtualCatalogs/replace',
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const getVirtualCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const deprecateVirtualCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const createDraftCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const updateDraftCatalogPrivateMethod = (virtualCatalogCode: string, catalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft/{catalogCode}', {virtualCatalogCode: virtualCatalogCode,catalogCode: catalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.PUT,
  };
};

export const deleteDraftCatalogPrivateMethod = (virtualCatalogCode: string, catalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/draft/{catalogCode}', {virtualCatalogCode: virtualCatalogCode,catalogCode: catalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const publishDraftCatalogPrivateMethod = (virtualCatalogCode: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/virtualCatalogs/{virtualCatalogCode}/publish-draft', {virtualCatalogCode: virtualCatalogCode,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getReportsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/reports',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getGeneratedReportPrivateMethod = (reportId: string, query: {  onlineReportId: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/reports/{reportId}', {reportId: reportId,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const generateReportPrivateMethod = (reportId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/reports/{reportId}', {reportId: reportId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postPunchoutOrderPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/punchout/orders',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getContractsPrivateMethod = (query?: {  contractDisplayId?: string; mdmId?: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contracts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postContractPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/contracts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const postTerminateContractPrivateMethod = (contractDisplayId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/contracts/{contractDisplayId}/terminate', {contractDisplayId: contractDisplayId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getDeliveryMethodsPrivateMethod = (query?: {  productType?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/delivery-methods' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postServiceFeePrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/service-fee',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getAddOnVisibilityPrivateMethod = (commercialProductCode: string, query: {  operationType: string; }): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/addon-visibility/{commercialProductCode}', {commercialProductCode: commercialProductCode,}) + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const globalSearchPrivateMethod = (query: {  query: string; searchType?: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/global-search' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const licenseManagementUrlPrivateMethod = (query: {  accountId: number; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/get-license-management-url' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getLicenseManagementAccountsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/get-license-management-accounts',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postCreateInterworksAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/create-interworks-account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormAccountPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/account',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormAddressPrivateMethod = (query: {  addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/address' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormProductAvailabilityPrivateMethod = (query: {  formId: string; subscriptionTypes: string[]; addressId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/product-availability' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const deleteOpenFormDraftsPrivateMethod = (query: {  referenceNumbers: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

export const getOpenFormDraftItemListPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postOpenFormDraftPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/draft',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormDraftPrivateMethod = (referenceNumber: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/openform/draft/{referenceNumber}', {referenceNumber: referenceNumber,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormPrivateMethod = (query: {  formId: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/form' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const postOpenFormCustomerNeedPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/form',
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOpenFormItemListPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/list',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getOpenFormSummaryPrivateMethod = (query: {  choices: string[]; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/openform/summary' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const parameterizedSearchContactsPrivateMethod = (query: {  searchTerm: string; }): ApiMethod => {
  return {
    path: '/api/ui/v2/private/parameterized-search/contacts' + getQueryString(query),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const getMfaDetailsPrivateMethod = (): ApiMethod => {
  return {
    path: '/api/ui/v2/private/mfa/details',
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const enableMfaPrivateMethod = (serviceAgreementId: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/mfa/enable/{serviceAgreementId}', {serviceAgreementId: serviceAgreementId,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const getOmalaskuStatusPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.GET,
  };
};

export const activateOmalaskuPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.POST,
  };
};

export const cancelOmalaskuPrivateMethod = (msisdn: string): ApiMethod => {
  return {
    path: replacePathParams('/api/ui/v2/private/omalasku/{msisdn}', {msisdn: msisdn,}),
    type: ApiType.PRIVATE,
    verb: ApiVerb.DELETE,
  };
};

